import React from "react";
import { ChangeEvent, FormEvent, Fragment, MouseEvent } from "react";
import ReactModal from "react-modal";
import { Link } from "react-router-dom";
import { RouteComponentPropsHistory } from "../../types";

import DelayInput from "../DelayInput";
import HasRight from "../HasRight";
import LinkTr from "../LinkTr";
import OverflowMenuItem from "../OverflowMenuItem";
import ToolbarMenuItem from "../ToolbarMenuItem";
import ViewToolbar from "../ViewToolbar";

import { V2 } from "../../Api";
import { formatDateLocalNumeric, truncateEllipse } from "../../Utilities";
import withTitle, { IViewTitleProps } from "../withTitle";

import "../../form.css";
import "../../tasks.css";
import "../viewer.css";

interface ITaskListViewState {
    isLoading: boolean | string;
    isLoadingTable: boolean | string;

    activeGroup: any;
    searchText: string;

    tasks: any[];

    groups: any[];

    showGroupList: boolean;

    dialogError: string;
    isModalOpen: boolean;
    userId: string;
    userName: string;
    users: any[];

    [name: string]: any;
}

class TaskListView extends React.Component<RouteComponentPropsHistory<any, any> & IViewTitleProps, ITaskListViewState> {
    constructor(props: Readonly<RouteComponentPropsHistory<any, any> & IViewTitleProps>) {
        super(props);

        const state: ITaskListViewState = {
            isLoading: false,
            isLoadingTable: true,

            activeGroup: { id: "active", name: "Active" },

            searchText: "",

            tasks: [],

            groups: [
                { id: "active", name: "Active", count: 0, sort: "asc", sortBy: "last_note" },
                { id: "completed", name: "Completed", count: 0, sort: "desc", sortBy: "completed" },
                { id: "_search", name: "Search", count: 0, hidden: true },
            ],

            showGroupList: false,

            dialogError: "",
            isModalOpen: false,
            userId: "",
            userName: "",
            users: [],
        };

        if (this.props.location.state) {
            state.searchText = this.props.location.state.searchText;
            state.activeGroup = this.props.location.state.activeGroup;
            if (state.activeGroup && state.activeGroup.id === "_search") {
                (state.groups as any[]).find(a => a.id === "_search").hidden = false;
            }
            else if (!state.activeGroup) {
                state.activeGroup = { id: "active", name: "Active" };
            }

            if (this.props.location.state.delegatedUserId) {
                state.userId = this.props.location.state.delegatedUserId;
                state.userName = this.props.location.state.delegatedUserName;

                window.setTimeout(() => this.props.viewTitleContext.changeTitle(`${state.userName}'s Task List`, "both"), 100)
            }
        }

        this.state = state;

        this.handleSearch = this.handleSearch.bind(this);
        this.switchGroups = this.switchGroups.bind(this);
        this.saveSearchState = this.saveSearchState.bind(this);
        this.toggleGroupList = this.toggleGroupList.bind(this);
        this.showUserDialog = this.showUserDialog.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.showOtherUserTasks = this.showOtherUserTasks.bind(this);
        this.viewOwnTaskList = this.viewOwnTaskList.bind(this);
        this.formInputChanged = this.formInputChanged.bind(this);
    }

    public async componentDidMount() {
        await this.loadTasks();
    }

    public render() {
        if (this.state.isLoading === true) {
            return <div className="spinner-center lds-dual-ring-big" />;
        }
        else if (typeof this.state.isLoading === "string") {
            return <span className="error-text">{this.state.isLoading}</span>;
        }

        return (
            <div className="viewer-root viewer-full">
                <ViewToolbar>
                    <HasRight right="tasks:create">
                        <Link to="/tasks/new" className="icon-plus" title="Create New Task" />
                    </HasRight>
                    <OverflowMenuItem>
                        <ToolbarMenuItem right="tasks:read:all">
                            <button title="View user's task list" onClick={this.showUserDialog}><i className="icon-user" />View another user's task list</button>
                        </ToolbarMenuItem>
                        <ToolbarMenuItem condition={!!this.state.userId}>
                            <button title="View your task list" onClick={this.viewOwnTaskList}><i className="icon-reply" />Back to your task list</button>
                        </ToolbarMenuItem>
                    </OverflowMenuItem>
                </ViewToolbar>
                <ReactModal
                    isOpen={this.state.isModalOpen} onRequestClose={this.closeDialog}
                    overlayClassName="modal-overlay" className="modal-content" portalClassName="modal-portal"
                    bodyOpenClassName="modal-open"
                    contentLabel="View user's tasks">
                    <form className="input-form" onSubmit={this.showOtherUserTasks}>
                        <section className="info-block">
                            <header>
                                <h3>View user's tasks</h3>
                            </header>

                            {
                                (this.state.users && this.state.users.length === 0)
                                    ? <div className="spinner spinner-center lds-dual-ring" />
                                    : <Fragment>
                                        <p>Select the user who's task list you want to view</p>
                                        <section>
                                            <div className="input-form-group">
                                                <label htmlFor="frm-user">User</label>
                                                <select id="frm-user" name="userId" value={this.state.userId} onChange={this.formInputChanged} autoComplete="off_please_chrome">
                                                    <option value="" />
                                                    {this.state.users.map(a => <option key={a.id} value={a.id}>{a.displayName}</option>)}
                                                </select>
                                            </div>
                                        </section>
                                    </Fragment>
                            }
                            &nbsp;
                            <div className="action-panel-dialog">
                                <button type="submit" className="button push-right" disabled={!this.state.userId}>View</button>
                                <button type="button" className="button" onClick={this.closeDialog}>Close</button>
                            </div>
                        </section>
                    </form>
                </ReactModal>
                <div className="filter-control-box">
                    <div className="tasks-control-left">
                        <HasRight right="tasks:create">
                            {!this.state.userId
                                ? <Link to="/tasks/new" className="button text-with-icon"><i className="icon-plus" /><span>New Task</span></Link>
                                : <button className="button text-with-icon" disabled={true}><i className="icon-plus" /><span>New Task</span></button>
                            }
                        </HasRight>
                    </div>
                    <div className="control-group fill-space">
                        <button className="button small tasks-group-toggle" onClick={this.toggleGroupList}><i className="icon-tags" /></button>
                        <DelayInput type="search" className="fill-space" placeholder="Search tasks..." timeout={500} onChangeDelayed={this.handleSearch} value={this.state.searchText} />
                    </div>
                </div>
                <div className="tasks-double-pane">
                    <div className={"tasks-left-pane" + (this.state.showGroupList ? " tasks-groups-shown" : "")}>
                        <ul className="tasks-group-list">
                            {
                                this.state.groups.filter(a => !a.hidden).map(a => <li key={a.id} className={a.id === this.state.activeGroup.id ? "tasks-group-active" : ""}>
                                    <button className="tasks-group-button" onClick={this.switchGroups} data-group={a.id}>{a.name}{a.count ? <span className="tasks-group-count">{a.count}</span> : ""}</button>
                                </li>)
                            }
                        </ul>
                    </div>
                    <div className="tasks-main-pane">
                        <table className="table-vertical section-table tasks-list">
                            <thead className="table-vertical-head-always">
                                <tr>
                                    <th colSpan={10}>Tasks &mdash; {this.state.activeGroup.name}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.isLoadingTable
                                        ? <tr>
                                            <td colSpan={10}>
                                                {
                                                    typeof this.state.isLoadingTable === "string"
                                                        ? <span className="error-text">{this.state.isLoadingTable}</span>
                                                        : <div className="spinner spinner-center lds-dual-ring-small" />
                                                }
                                            </td>
                                        </tr>
                                        : this.state.tasks.length === 0
                                            ? <tr><td colSpan={10}>No tasks</td></tr>
                                            : this.state.tasks.map(a => (
                                                <LinkTr key={a.id} to={{ pathname: `/tasks/${a.id}`, state: { userId: this.state.userId || undefined } }}>
                                                    <td>{a.hasAttachments ? <i className="icon-paperclip icon-style-larger" title="Has attachment(s)" /> : null}</td>
                                                    <td className="wrap">{a.subject}</td>
                                                    <td className="wrap" data-caption="Note: ">{truncateEllipse(a.lastNote?.replace(/[\r\n]/g, " "), 50)}</td>
                                                    <td className="col-smallest" data-caption="Date Created: ">{formatDateLocalNumeric(a.timestamp)}</td>
                                                </LinkTr>))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }

    private handleSearch(e: ChangeEvent<HTMLInputElement>) {
        const value = e.currentTarget.value;

        const newState: Partial<ITaskListViewState> = {
            searchText: value
        };

        if (!value) {
            // Default to active
            newState.activeGroup = this.state.groups[0];
            this.state.groups.find(a => a.id === "_search").hidden = true;
        }
        else {
            // Show search group
            newState.activeGroup = { id: "_search", name: "Search Results" };
            this.state.groups.find(a => a.id === "_search").hidden = false;
        }
        newState.groups = this.state.groups;


        this.setState(newState as any, () => this.loadTasks());
    }

    private async loadTasks() {
        try {
            const parameters = [];
            const groupParameters = [];

            const loadState: Partial<ITaskListViewState> = {
                isLoadingTable: true
            };

            if (this.state.searchText) {
                parameters.push(`query=${encodeURIComponent(this.state.searchText)}`);
                parameters.push(`sort=desc`);
            }
            else {
                parameters.push(`status=${this.state.activeGroup.id || "active"}`);
                parameters.push(`sort=${this.state.activeGroup.sort || "asc"}`);
                parameters.push(`sort_by=${this.state.activeGroup.sortBy || "timestamp"}`);
            }

            if (this.state.userId) {
                parameters.push(`user=${this.state.userId}`);
                groupParameters.push(`user=${this.state.userId}`);
            }

            this.setState(loadState as any);

            const [groups, items] = await Promise.all([
                V2.get<any>(`tasks/groups?${groupParameters.join("&")}`),
                V2.get<any>(`tasks/summary?${parameters.join("&")}`),
            ]);

            this.state.groups.forEach((v, i) => {
                v.count = (groups.find((b: any) => b.group === v.id) || { count: 0 }).count;
            });

            if (this.state.searchText) {
                this.state.groups.find(a => a.id === "_search").count = items.length;
            }

            if (this.state.userId) {
                this.props.viewTitleContext.changeTitle(`${this.state.userName}'s Task List`, "both");
            }
            else {
                this.props.viewTitleContext.changeTitle("Task List");
            }

            this.setState({
                groups: this.state.groups,
                isLoadingTable: false,
                tasks: items,
            }, () => this.saveSearchState());
        }
        catch (e) {
            this.setState({
                isLoadingTable: e.message
            });
        }
    }

    private switchGroups(e: MouseEvent<HTMLButtonElement>) {
        const groupName = e.currentTarget.dataset.group || "active";
        if (groupName === "_search") {
            return;
        }

        // Hide search group
        this.state.groups.find(a => a.id === "_search").hidden = true;

        this.setState(s => ({
            activeGroup: s.groups.find(a => a.id === groupName),
            searchText: "", // Clear search
        }), () => this.loadTasks());
    }

    private saveSearchState() {
        const location = this.props.location;
        location.state = {
            activeGroup: this.state.activeGroup,
            delegatedUserId: this.state.userId,
            delegatedUserName: this.state.userName,
            searchText: this.state.searchText,
        };

        this.props.history.replace(location);
    }

    private toggleGroupList() {
        this.setState(s => ({
            showGroupList: !s.showGroupList
        }));
    }

    private showUserDialog() {
        this.setState({
            isModalOpen: true,
        }, async () => {
            try {
                const users = await V2.get<any[]>("users/summary");

                users.sort((a, b) => a.displayName.localeCompare(b.displayName));

                this.setState({
                    dialogError: "",
                    users
                });
            }
            catch (e) {
                this.setState({
                    dialogError: e.message
                });
            }
        });
    }

    private closeDialog() {
        this.setState({
            isModalOpen: false,
        });
    }

    private showOtherUserTasks(e: FormEvent) {
        e.preventDefault();

        this.setState(s => ({
            isModalOpen: false,

            userName: s.userId ? s.users.find(a => a.id === s.userId).displayName : "",
        }), () => this.loadTasks());
    }

    private viewOwnTaskList() {
        this.setState({
            userId: "",
            userName: "",
        }, () => this.loadTasks());
    }

    private formInputChanged(e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement> | ChangeEvent<HTMLSelectElement>) {
        const name = e.currentTarget.name;
        const value = e.currentTarget.type === "checkbox" ? (e.currentTarget as HTMLInputElement).checked : e.currentTarget.value;


        this.setState({
            [name]: value
        });

    }
}

export default withTitle("Task List", TaskListView);
